import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../common/Sidebar";
import { useEffect, useState } from "react";
import colors from "../../assets/ts/colors";

const MainLayout = () => {
  const location = useLocation();
  const [is_not_expand, setIsNotExpand] = useState(window.innerWidth < 992); // <-- set false/true based on screen size
  const [widthExpand, setWidthExpand] = useState(window.innerWidth >= 992);

  useEffect(() => {
    const handleResize = () => {
      const isLarge = window.innerWidth >= 992;
      setWidthExpand(isLarge);

      // Automatically collapse sidebar on small devices
      setIsNotExpand(!isLarge);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Toggle sidebar manually
  const toggleSidebar = () => setIsNotExpand((prev) => !prev);

  // Call this on page change if needed
  const expandPage = () => {
    if (!widthExpand) {
      setIsNotExpand(true); // collapsed on small screens
    }
  };

  const templateViewStyle =
    location.pathname === "/admin/livesupport" ? { marginLeft: 0 } : {};

  return (
    <div style={{ background: colors.backgroundColor, minHeight: "100vh", backgroundAttachment: "fixed" }}>
      <Sidebar
        is_not_expand={is_not_expand}
        widthExpand={widthExpand}
        call={toggleSidebar}
        callpage={expandPage}
      />
      <div
        className={`template-view ${is_not_expand ? "not-expand" : "expand"}`}
        style={templateViewStyle}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
